import {
  type AppEnvironment,
  developmentEnvironment,
} from '@automatick/shared-ts';

export const environment = {
  ...developmentEnvironment,
  SESSION_TIMEOUT: { ...developmentEnvironment.SESSION_TIMEOUT },
  observability: { ...developmentEnvironment.observability },
  WEBRTC_ICE_SERVERS: [...developmentEnvironment.WEBRTC_ICE_SERVERS],
} as const satisfies AppEnvironment;
